import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tooltip, { POSITION, ALIGN } from 'gnos-tooltip'
import { FormattedMessage } from 'react-intl'
import log from 'loglevel'
import _ from 'lodash'
import cx from 'classnames'

import config from '@config'

import { LOCALE_PREFIX } from './components/Tab/constants'
import Tab from './components/Tab'

import { TAB_TYPE } from './constants'
import { getCookie } from './helpers'

import './style.scss'

const entityStackConfig = config.components.entityStack

export default class TabBar extends Component {
    static propTypes = {
        activeGroupId: PropTypes.string,
        activeTab: PropTypes.string.isRequired,
        entityStackRemoveNotification: PropTypes.func.isRequired,
        changeEntityStackTab: PropTypes.func.isRequired,
        notifications: PropTypes.object,
        swChangeEntityStackTab: PropTypes.func.isRequired,
        toggleEntityStack: PropTypes.func.isRequired,
    }

    handleToggleEntityStack = () => {
        const { toggleEntityStack, activeGroupId } = this.props

        if (!activeGroupId) {
            toggleEntityStack()

            // Delay the resize event until the entityStack animation (500ms) is finished
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'))
            }, 650)
        }
    }

    handleFilter = () => {
        log.info('Filter handler')
    }

    render() {
        const {
            activeTab,
            changeEntityStackTab,
            activeGroupId,
            swChangeEntityStackTab,
            entityStackRemoveNotification,
            notifications,
        } = this.props

        let tabsArr = TAB_TYPE
        if (getCookie('sessionMode') === 'permanent') {
            tabsArr = tabsArr.filter((x) => {
                if (!['favourites', 'groups'].includes(x)) {
                    return x
                }

                return null
            })
        }

        return (
            <div className="entity-stack-tabs">
                <div className="tab-container">
                    {tabsArr.map(
                        (tabType, index) =>
                            _.get(entityStackConfig, `${tabType}.visible`) && (
                                <Tab
                                    key={`entity-stack-tab-${index}`}
                                    activeTab={activeTab}
                                    type={tabType}
                                    changeEntityStackTab={changeEntityStackTab}
                                    swChangeEntityStackTab={swChangeEntityStackTab}
                                    entityStackRemoveNotification={entityStackRemoveNotification}
                                    hasNotification={!!notifications[tabType]}
                                />
                            )
                    )}
                </div>
                <div className="tab-container">
                    {_.get(entityStackConfig, 'collapse.visible') && (
                        <Tooltip
                            id={`entity-stack-type-collapse-tooltip`}
                            content={
                                <FormattedMessage
                                    id={`${LOCALE_PREFIX}.tooltip.collapse`}
                                    values={{ br: <br />, b: (chunks) => <b>{chunks}</b> }}
                                />
                            }
                            position={POSITION.BOTTOM}
                            align={ALIGN.START}
                        >
                            <div
                                className={cx('entity-stack-tab collapse', {
                                    'is-disabled': !!activeGroupId,
                                })}
                                onClick={this.handleToggleEntityStack}
                            />
                        </Tooltip>
                    )}

                    {_.get(entityStackConfig, 'filter.visible') && (
                        <Tooltip
                            id={`entity-stack-type-filter-tooltip`}
                            content={
                                <FormattedMessage
                                    id={`${LOCALE_PREFIX}.tooltip.filter`}
                                    values={{ br: <br />, b: (chunks) => <b>{chunks}</b> }}
                                />
                            }
                            position={POSITION.BOTTOM}
                            align={ALIGN.START}
                        >
                            <div className="entity-stack-tab filter" onClick={this.handleFilter} />
                        </Tooltip>
                    )}
                </div>
            </div>
        )
    }
}
